"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// You can customize below settings :)
const settings = {
  title: process.env.VUE_APP_TITLE || 'Vue3 Admin Template',
  showSettings: true,
  showTagsView: true,
  fixedHeader: false,
  showSidebarLogo: true,
  errorLog: ['production'],
  sidebarTextTheme: false,
  devServerPort: 9527
};
var _default = exports.default = settings;